import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "admin-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NcNoteCard = _resolveComponent("NcNoteCard")!
  const _component_NcTextField = _resolveComponent("NcTextField")!
  const _component_NcCheckboxRadioSwitch = _resolveComponent("NcCheckboxRadioSwitch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.$options.title), 1),
    (_ctx.status)
      ? (_openBlock(), _createBlock(_component_NcNoteCard, {
          key: 0,
          type: _ctx.binaryStatusType(_ctx.status.exiftool)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.binaryStatus('exiftool', _ctx.status.exiftool)), 1)
          ]),
          _: 1
        }, 8, ["type"]))
      : _createCommentVNode("", true),
    _createVNode(_component_NcTextField, {
      label: _ctx.t('memories', 'Path to packaged exiftool binary'),
      "label-visible": true,
      "model-value": _ctx.config['memories.exiftool'],
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.update('memories.exiftool', $event.target.value))),
      readonly: ""
    }, null, 8, ["label", "model-value"]),
    (_ctx.status)
      ? (_openBlock(), _createBlock(_component_NcNoteCard, {
          key: 1,
          type: _ctx.binaryStatusType(_ctx.status.perl, false)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.binaryStatus('perl', _ctx.status.perl)) + " " + _toDisplayString(_ctx.t('memories', 'You need perl only if the packaged exiftool binary does not work for some reason.')), 1)
          ]),
          _: 1
        }, 8, ["type"]))
      : _createCommentVNode("", true),
    _createVNode(_component_NcCheckboxRadioSwitch, {
      modelValue: _ctx.config['memories.exiftool_no_local'],
      "onUpdate:modelValue": [
        _cache[1] || (_cache[1] = ($event: any) => ((_ctx.config['memories.exiftool_no_local']) = $event)),
        _cache[2] || (_cache[2] = ($event: any) => (_ctx.update('memories.exiftool_no_local')))
      ],
      type: "switch"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t('memories', 'Use system perl (only if exiftool binary does not work)')), 1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}